import React, {Component} from 'react';
import {Grid, Image} from 'semantic-ui-react';
import FileUpload from '../fileUpload';

class ImageUpload extends Component {
  showThumbnail() {
    const {preview} = this.props;

    return preview ? preview : '/media/placeholder.png';
  }

  showClearButton() {
    const {onClear, preview, loading} = this.props;

    if (onClear && preview && !loading) {
      return {
        'as': 'a',
        'color': 'red',
        'corner': 'right',
        'icon': 'close',
        'onClick': onClear,
      };
    }

    return null;
  }

  render() {
    const {name, loading, onChange} = this.props;

    return (
      <Grid className='tems-image-upload'>
        <Grid.Row columns='2'>
          <Grid.Column>
            <Image
              size='small'
              className='tems-image-preview'
              src={this.showThumbnail()}
              label={this.showClearButton()}
            />
          </Grid.Column>
          <Grid.Column verticalAlign='middle'>
            <FileUpload
              name={name}
              loading={loading}
              text='SUBIR ARCHIVO'
              supportedFiles='image/*'
              changeActions={onChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ImageUpload;
